import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M4.47 1.97a.75.75 0 0 1 1.06 0l2.576 2.576A6.4 6.4 0 0 1 10 4.25c1.668 0 3.176.705 4.395 1.554 1.223.852 2.213 1.89 2.857 2.651l.068.08c.325.38.697.816.697 1.465s-.372 1.084-.697 1.465l-.068.08c-.28.332-.628.716-1.03 1.115l1.808 1.81a.75.75 0 0 1-1.06 1.06L4.47 3.03a.75.75 0 0 1 0-1.06m5.766 4.705-.879-.879q.32-.046.643-.046c1.245 0 2.455.53 3.538 1.285 1.077.75 1.972 1.683 2.57 2.39.21.248.31.37.37.47.039.063.039.08.039.103v.004c0 .023 0 .04-.038.103-.06.1-.162.222-.372.47-.261.31-.58.663-.946 1.025l-1.836-1.836a3.334 3.334 0 0 0-3.09-3.09Z"
      clipRule="evenodd"
    />
    <path d="M6.05 7.338a14.5 14.5 0 0 0-2.157 2.087c-.21.248-.312.37-.372.47-.038.063-.038.08-.038.103v.004c0 .023 0 .04.038.103.06.1.161.222.372.47.597.707 1.492 1.64 2.57 2.39 1.082.754 2.292 1.285 3.537 1.285.813 0 1.611-.226 2.368-.594l1.112 1.112c-1.029.572-2.208.982-3.48.982-1.668 0-3.176-.705-4.395-1.554-1.223-.852-2.213-1.89-2.857-2.651l-.068-.08c-.325-.38-.697-.816-.697-1.465s.372-1.084.697-1.465l.068-.08A16 16 0 0 1 4.98 6.27z" />
    <path d="M6.667 10c0-.59.153-1.144.421-1.624l1.143 1.142a1.835 1.835 0 0 0 2.25 2.251l1.143 1.143A3.333 3.333 0 0 1 6.667 10" />
  </svg>
);
export default SvgHide;
